import {HTTP, ERROR} from '@/http-common';
import router from '../../router/index';
import moment from "moment";
import FileSaver from "file-saver";

const state = {
  loading: false,
  messages: [],
  resultsCount: 0,
  stats: {
    all: 0,
    sent: 0
  }
};

const mutations = {
  SET_MASS_MESSAGES_DETAILS(state, data) {
    state.messages = data
  },
  SET_MASS_MESSAGES_DETAILS_COUNT(state, data) {
    state.resultsCount = data
  },
  SET_MASS_MESSAGES_DETAILS_STATS(state, data) {
    state.stats = data
  }
};

const getters = {
  getMassMessagesDetails: state => state.messages,
  getMassMessagesDetailsCount: state => state.resultsCount,
  getMassMessagesStats: state => state.stats
};

const actions = {
  GET_MASS_MESSAGES_DETAILS_ACTION: ({commit}, payload) => {
    state.loading = true
    HTTP.post(`mass-messages/details/${router.currentRoute.params.id}`, payload)
      .then(response => {
        ERROR(response)
        if (response.status === 200) {
          commit('SET_MASS_MESSAGES_DETAILS', response.data.data.records.data);
          commit('SET_MASS_MESSAGES_DETAILS_COUNT', response.data.data.records.results_num);
          commit('SET_MASS_MESSAGES_DETAILS_STATS', response.data.data.stats);
          state.loading = false
        }
      }).catch(err => {
      console.log(err);
      state.loading = false
    })
  },
  MASS_MESSAGES_EXPORT_HISTORY: ({commit}, payload) => {
    HTTP.get(`mass-messages/history/export?id=${router.currentRoute.params.id}`)
      .then(response => {
        ERROR(response);
        var blob = new Blob([response.data], {type: response.headers['content-type']});
        FileSaver.saveAs(blob, `MassMessages_${router.currentRoute.params.id}.csv`);
      }).catch(err => {
      console.log(err);
    })
  },
};

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/massMessagesDetails.js